export const COMMON_SET_RECIPE_DATA = 'COMMON_SET_RECIPE_DATA';
export const COMMON_SET_RECIPE_LOADING = 'COMMON_SET_RECIPE_LOADING';
export const COMMON_SET_RECIPE_ERROR = 'COMMON_SET_RECIPE_ERROR';



// WEBPACK FOOTER //
// ./src/state/getrecipe/types.js